/**
 * The block, trigger and connector catalogues — the names and descriptions a
 * person reads when picking one, translated where they are rendered rather
 * than in the registry files, which are upstream.
 *
 * One half of `AGENT_COPY`. The shape and the rules are documented on the
 * barrel in `../agent-copy.ts`; this file only holds entries.
 */
export const CATALOG: Record<string, string> = {};
